"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _createSvg = require("../createSvg");

var _interfaces = require("../interfaces");

var _SVGIconWithSizes;

var _default = (0, _createSvg.createSvg)('IconBin', new _interfaces.SVGIconWithSizes((_SVGIconWithSizes = {}, (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.ExtraSmall, {
  paths: ['M4.25 14.4H11.75V3.2H4.25V14.4ZM6.5 12.8C6.91475 12.8 7.25 12.4424 7.25 12V5.6C7.25 5.1576 6.91475 4.8 6.5 4.8C6.08525 4.8 5.75 5.1576 5.75 5.6V12C5.75 12.4424 6.08525 12.8 6.5 12.8ZM10.25 12C10.25 12.4424 9.91475 12.8 9.5 12.8C9.08525 12.8 8.75 12.4424 8.75 12V5.6C8.75 5.1576 9.08525 4.8 9.5 4.8C9.91475 4.8 10.25 5.1576 10.25 5.6V12ZM13.25 1.6H12.5H10.25V0.8C10.25 0.3576 9.91475 0 9.5 0H6.5C6.08525 0 5.75 0.3576 5.75 0.8V1.6H3.5H2.75C2.33525 1.6 2 1.9576 2 2.4C2 2.8424 2.33525 3.2 2.75 3.2V15.2C2.75 15.6424 3.08525 16 3.5 16H12.5C12.9148 16 13.25 15.6424 13.25 15.2V3.2C13.6648 3.2 14 2.8424 14 2.4C14 1.9576 13.6648 1.6 13.25 1.6V1.6Z'],
  params: {
    height: '16',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 16,
  width: 16
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Small, {
  paths: ['M5 18H15V4H5V18ZM8 16C8.553 16 9 15.553 9 15V7C9 6.447 8.553 6 8 6C7.447 6 7 6.447 7 7V15C7 15.553 7.447 16 8 16ZM13 15C13 15.553 12.553 16 12 16C11.447 16 11 15.553 11 15V7C11 6.447 11.447 6 12 6C12.553 6 13 6.447 13 7V15ZM17 2H16H13V1C13 0.447 12.553 0 12 0H8C7.447 0 7 0.447 7 1V2H4H3C2.447 2 2 2.447 2 3C2 3.553 2.447 4 3 4V19C3 19.553 3.447 20 4 20H16C16.553 20 17 19.553 17 19V4C17.553 4 18 3.553 18 3C18 2.447 17.553 2 17 2V2Z'],
  params: {
    height: '20',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 20,
  width: 20
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Medium, {
  paths: ['M6.00002 21.6H18V4.8H6.00002V21.6ZM9.60002 19.2C10.2636 19.2 10.8 18.6636 10.8 18V8.4C10.8 7.7364 10.2636 7.2 9.60002 7.2C8.93642 7.2 8.40002 7.7364 8.40002 8.4V18C8.40002 18.6636 8.93642 19.2 9.60002 19.2ZM15.6 18C15.6 18.6636 15.0636 19.2 14.4 19.2C13.7364 19.2 13.2 18.6636 13.2 18V8.4C13.2 7.7364 13.7364 7.2 14.4 7.2C15.0636 7.2 15.6 7.7364 15.6 8.4V18ZM20.4 2.4H19.2H15.6V1.2C15.6 0.5364 15.0636 0 14.4 0H9.60002C8.93642 0 8.40002 0.5364 8.40002 1.2V2.4H4.80002H3.60002C2.93642 2.4 2.40002 2.9364 2.40002 3.6C2.40002 4.2636 2.93642 4.8 3.60002 4.8V22.8C3.60002 23.4636 4.13642 24 4.80002 24H19.2C19.8636 24 20.4 23.4636 20.4 22.8V4.8C21.0636 4.8 21.6 4.2636 21.6 3.6C21.6 2.9364 21.0636 2.4 20.4 2.4V2.4Z'],
  params: {
    height: '24',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 24,
  width: 24
}), (0, _defineProperty2.default)(_SVGIconWithSizes, _interfaces.IconSize.Large, {
  paths: ['M8.00001 28.8H24V6.4H8.00001V28.8ZM12.8 25.6C13.6848 25.6 14.4 24.8848 14.4 24V11.2C14.4 10.3152 13.6848 9.6 12.8 9.6C11.9152 9.6 11.2 10.3152 11.2 11.2V24C11.2 24.8848 11.9152 25.6 12.8 25.6ZM20.8 24C20.8 24.8848 20.0848 25.6 19.2 25.6C18.3152 25.6 17.6 24.8848 17.6 24V11.2C17.6 10.3152 18.3152 9.6 19.2 9.6C20.0848 9.6 20.8 10.3152 20.8 11.2V24ZM27.2 3.2H25.6H20.8V1.6C20.8 0.7152 20.0848 0 19.2 0H12.8C11.9152 0 11.2 0.7152 11.2 1.6V3.2H6.40001H4.80001C3.91521 3.2 3.20001 3.9152 3.20001 4.8C3.20001 5.6848 3.91521 6.4 4.80001 6.4V30.4C4.80001 31.2848 5.51521 32 6.40001 32H25.6C26.4848 32 27.2 31.2848 27.2 30.4V6.4C28.0848 6.4 28.8 5.6848 28.8 4.8C28.8 3.9152 28.0848 3.2 27.2 3.2V3.2Z'],
  params: {
    height: '32',
    xmlns: 'http://www.w3.org/2000/svg'
  },
  height: 32,
  width: 32
}), _SVGIconWithSizes)));

exports.default = _default;